/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Viewerで表示される各書店リンク（例：amazon、シーモア）と各書店のロゴ画像
 * @export
 * @interface StoreItemVolumeLinkViewerModel
 */
export interface StoreItemVolumeLinkViewerModel {
    /**
     * コミチ内で単行本の書店リンクに付与される一意のID
     * @type {number}
     * @memberof StoreItemVolumeLinkViewerModel
     */
    id: number;
    /**
     * 各書店のURL
     * @type {string}
     * @memberof StoreItemVolumeLinkViewerModel
     */
    url: string;
    /**
     * 各書店の名
     * @type {string}
     * @memberof StoreItemVolumeLinkViewerModel
     */
    name: string;
    /**
     * 各書店アイコンのバナー
     * @type {string}
     * @memberof StoreItemVolumeLinkViewerModel
     */
    banner?: string;
}

/**
 * Check if a given object implements the StoreItemVolumeLinkViewerModel interface.
 */
export function instanceOfStoreItemVolumeLinkViewerModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "url" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function StoreItemVolumeLinkViewerModelFromJSON(json: any): StoreItemVolumeLinkViewerModel {
    return StoreItemVolumeLinkViewerModelFromJSONTyped(json, false);
}

export function StoreItemVolumeLinkViewerModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreItemVolumeLinkViewerModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'url': json['url'],
        'name': json['name'],
        'banner': !exists(json, 'banner') ? undefined : json['banner'],
    };
}

export function StoreItemVolumeLinkViewerModelToJSON(value?: StoreItemVolumeLinkViewerModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'url': value.url,
        'name': value.name,
        'banner': value.banner,
    };
}

